import InitApi from "api/InitApi";
import { useMutation, useQueryClient } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import { ECOCASH_API_TIMEOUT } from "utils/paymentConfig";

const useEcocashPaySubscription = (setPaymentIsSuccessful = null) => {
	const { accessToken } = useTokenStore();

	const queryClient = useQueryClient();

	const history = useHistory();
	const location = useLocation();
	const retryUrl = location.pathname;

	const save = async (obj) => {
		const instance = await InitApi({ accessToken });

		const body = deleteEmptyObjects(obj);

		const response = await instance.post(
			`/subscriptions/subscribe/${body?.id}`,
			body,
			{
				timeout: ECOCASH_API_TIMEOUT,
				timeoutErrorMessage: "Payment request timed out. Please try again.",
			}
		);
		await queryClient.invalidateQueries("is_subscribed");
		await queryClient.invalidateQueries("picks");
		await queryClient.invalidateQueries("purchased");
		await queryClient.invalidateQueries("subscribedBooks");
		await queryClient.invalidateQueries("profile");
		return response?.data;
	};

	return useMutation(save, {
		onSuccess: async ({ data }) => {
			const queryString = `retryUrl=${retryUrl}&order_id=${data?.id}&ecocash_reference=${data?.ecocash_reference}&reference=${data?.reference}&phone=${data?.phone}&has_picks=${data?.has_picks}`;

			// EcoCash is asynchronous: always redirect to the polling/status page unless it failed immediately.
			if (data?.status === "Failed") {
				history.push(`/subscription-response?status=Failed&${queryString}`);
				return;
			}

			history.push(`/subscription-response?${queryString}`);
		},
		onError: async (error) => {
			queryClient.invalidateQueries("is_subscribed");
			queryClient.invalidateQueries("picks");
			queryClient.invalidateQueries("purchased");
			queryClient.invalidateQueries("subscribedBooks");

			const errorMsg =
				error?.response?.data?.message ||
				"Something went wrong. Please try again later.";
			const queryString = `retryUrl=${retryUrl}&payment_method=EcoCash&error=${errorMsg}`;
			history.push(`/subscription-error-response?${queryString}`);
		},
	});
};

export default useEcocashPaySubscription;
